{
  window.onload = e => {
    // footer submenus opening
    document.querySelectorAll('.footer-container .has-submenu').forEach(elm=>{
        elm.querySelector(':scope > a').addEventListener('click', e=>{
            const parent = e.currentTarget.parentNode;
            if ( ! parent.classList.contains('active') ) {
                e.preventDefault();
                parent.classList.add('active');
                this._slideDown(parent.querySelector('.submenu'), 200);
                parent.querySelector('.submenu').setAttribute('aria-expanded', 'true');
            } else if ( e.currentTarget.getAttribute('href') == '#' ) {
                e.preventDefault();
                parent.classList.remove('active');
                this._slideUp(parent.querySelector('.submenu'), 200);
                parent.querySelector('.submenu').setAttribute('aria-expanded', 'false');
                elm.classList.remove('hover');
            }
        });
    });
  }
}